const MODULE_ALIASES = {
  changespage: "changesPage",
  "changes-page": "changesPage",
  changes_page: "changesPage",
  changes: "changesPage",
  employeemanagement: "employees",
  "employee-management": "employees",
  employee_management: "employees",
  payrollmanagement: "payroll",
  "payroll-management": "payroll",
  payroll_management: "payroll",
  attendancemanagement: "attendance",
  "attendance-management": "attendance",
  attendance_management: "attendance",
  advancementmanagement: "advancements",
  "advancement-management": "advancements",
  advancement_management: "advancements",
  salaryadvancements: "advancements",
  solfa: "advancements",
  "solfa-management": "advancements",
  adminlevels: "adminLevels",
  calendar: "calendar",
  reports: "reports",
  documents: "documents",
  leaves: "leaves",
  messages: "messages",
  configurations: "configurations",
};

const FEATURE_ALIASES = {
  promoteemployee: "promoteActions",
  promote: "promoteActions",
  demoteemployee: "demoteActions",
  demote: "demoteActions",
  transferemployee: "transferActions",
  transfer: "transferActions",
  salaryadjustment: "salaryActions",
  salary_change: "salaryActions",
  terminateemployment: "terminateActions",
  terminate: "terminateActions",
  suspendemployee: "suspendActions",
  suspend: "suspendActions",
  rehireemployee: "rehireActions",
  rehire: "rehireActions",
  contractupdate: "contractActions",
  contract_update: "contractActions",
  jobrotation: "rotationActions",
  rotation: "rotationActions",
  performancereview: "reviewActions",
  performance_review: "reviewActions",
  trainingassignment: "trainingActions",
  training: "trainingActions",
  approveactions: "approveActions",
  approve: "approveActions",
  rejectactions: "rejectActions",
  reject: "rejectActions",
  viewhistory: "viewHistory",
  viewpendingapprovals: "viewPendingApprovals",
  assignmanagers: "assignManagers",
  bulkactions: "bulkActions",
};

const normalizeKey = (value) => String(value || "").trim().toLowerCase();

const normalizeModuleName = (moduleName) => {
  const key = normalizeKey(moduleName);
  return MODULE_ALIASES[key] || key;
};

const normalizeFeatureName = (featureName) => {
  const key = normalizeKey(featureName);
  return FEATURE_ALIASES[key] || key;
};

export const normalizeAdminLevelPermissions = (adminLevelData) => {
  if (!adminLevelData || typeof adminLevelData !== "object") {
    return { modules: [], features: {} };
  }

  const modules = Array.isArray(adminLevelData.modules)
    ? adminLevelData.modules
        .map((item) => {
          if (typeof item === "string") return item;
          if (item?.module) return item.module;
          if (item?.moduleName) return item.moduleName;
          return null;
        })
        .filter(Boolean)
        .map(normalizeModuleName)
    : Array.isArray(adminLevelData.modulePermissions)
    ? adminLevelData.modulePermissions
        .filter((mp) => mp && mp.isEnabled !== false)
        .map((mp) => mp.module || mp.moduleName)
        .filter(Boolean)
        .map(normalizeModuleName)
    : [];

  const features = {};

  if (adminLevelData.features && typeof adminLevelData.features === "object" && !Array.isArray(adminLevelData.features)) {
    Object.entries(adminLevelData.features).forEach(([moduleName, permissionValue]) => {
      const normalizedModule = normalizeModuleName(moduleName);
      const normalizedFeatures = Array.isArray(permissionValue)
        ? permissionValue.map(normalizeFeatureName)
        : typeof permissionValue === "object"
        ? Object.entries(permissionValue)
            .filter(([, enabled]) => enabled)
            .map(([featureName]) => normalizeFeatureName(featureName))
        : typeof permissionValue === "string"
        ? [normalizeFeatureName(permissionValue)]
        : [];

      if (normalizedModule && normalizedFeatures.length) {
        features[normalizedModule] = normalizedFeatures;
      }
    });
  } else if (Array.isArray(adminLevelData.modulePermissions)) {
    adminLevelData.modulePermissions.forEach((mp) => {
      if (!mp || mp.isEnabled === false) return;
      const normalizedModule = normalizeModuleName(mp.module || mp.moduleName);
      if (!normalizedModule) return;
      const enabledFeatures = Array.isArray(mp.featurePermissions)
        ? mp.featurePermissions
            .filter((fp) => fp && fp.isEnabled !== false)
            .map((fp) => normalizeFeatureName(fp.featureName || fp.feature || fp.name))
            .filter(Boolean)
        : [];
      if (enabledFeatures.length) {
        features[normalizedModule] = enabledFeatures;
      }
    });
  }

  return { modules, features };
};

export const normalizeFeatureNameForModule = (moduleName, featureName) => {
  const normalizedModule = normalizeModuleName(moduleName);
  return normalizeFeatureName(featureName);
};

export const normalizePermissionFeatureName = (featureName) =>
  normalizeFeatureName(featureName);
